import type React from 'react';

import GuidedPromptForm from 'containers/admin/clients/client/tabs-components/ai-assistant/components/chat/guided-prompt-form/guided-prompt-form';

import {
  formatGuidedPromptAnswers,
  type GuidedPrompt,
  type GuidedPromptAnswers,
} from 'containers/admin/clients/client/tabs-components/ai-assistant/helpers/guided-prompt-helpers';

export interface GuidedPromptPartProps {
  data: GuidedPrompt[];
  onSubmit: (text: string) => void;
  onDismiss: () => void;
}

const GuidedPromptPart = ({
  data,
  onSubmit,
  onDismiss,
}: GuidedPromptPartProps): React.JSX.Element => {
  const handleFormSubmit = (answers: GuidedPromptAnswers): void => {
    const formattedText = formatGuidedPromptAnswers(data, answers);

    if (!formattedText) {
      onDismiss();

      return;
    }

    onSubmit(formattedText);
  };

  return (
    <GuidedPromptForm
      prompts={data}
      onSubmit={handleFormSubmit}
      onDismiss={onDismiss}
    />
  );
};

export default GuidedPromptPart;
